import React from 'react';
import { Button } from 'primereact/button';
import StaticPageLayout from '../layouts/StaticPageLayout';
import AboutUsContent from '../shared/content/AboutUsContent';

const AboutUs = () => {
    return (
        <StaticPageLayout>
            {/* Hero Section - Full Width */}
            <div className="relative overflow-hidden" style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                minHeight: '400px' 
            }}>
                <div className="absolute w-full h-full opacity-10">
                    <div className="absolute" style={{ 
                        top: '-10%', 
                        right: '-5%',
                        width: '300px',
                        height: '300px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                    <div className="absolute" style={{ 
                        bottom: '-15%', 
                        left: '-5%',
                        width: '400px',
                        height: '400px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                </div>
                
                <div className="relative z-1 px-4 py-6 md:py-8 lg:px-8">
                    <div className="text-center text-white">
                        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-4 fadeInDown animation-duration-1000">About Interestng</h1>
                        <p className="text-lg md:text-xl lg:text-2xl mb-4 md:mb-6 fadeInUp animation-duration-1000 animation-delay-200 px-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                            Transforming the lending industry through innovation and technology
                        </p>
                        <Button 
                            label="Join Our Journey" 
                            icon="pi pi-arrow-right" 
                            className="p-button-rounded p-button-md md:p-button-lg bg-white text-primary-500 border-none font-bold px-3 md:px-5 fadeInUp animation-duration-1000 animation-delay-400"
                            onClick={() => window.location.href = 'https://app.interestng.com/app/login'}
                        />
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <AboutUsContent showCTA={true} />
        </StaticPageLayout>
    );
};

export default AboutUs;